import React from 'react';
import {connect} from 'react-redux';

import {AppState} from "@Redux/store";
import {Dispatch} from "@Redux/type";
import {CampaignView} from "@Selectors/tool/survey/view/CampaignView";

interface CampaignToAnswerData {
  campaign: CampaignView
}

const CampaignToAnswer: React.FC<CampaignToAnswerProps> = ({campaign}) => {
  return <article className="col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2 text-center">
    <a href={`/${document.documentElement.lang}/tool/survey/campaigns/${campaign.id}`}>
      {campaign.logo !== null && <img className="img-fluid w-100" alt={campaign.armyName} src={`${process.env.CDN ?? ''}${campaign.logo}`} />}
      <h4 className="boxtitre">{(campaign.name || '').substring(0, 60)}</h4>
    </a>
  </article>
};

const mapStateToProps = (state: AppState, props: CampaignToAnswerData) => ({
  campaign: props.campaign
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignToAnswer);

type CampaignToAnswerProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
